import { createFileRoute } from '@tanstack/react-router';
import PayslipDashboard from '@/features/payslip-dashboard';
import { ProtectedRoute } from '@/components/auth/protected-route';
import { Permissions } from '@/constants/roles-permissions';

export const Route = createFileRoute('/_authenticated/payslip-dashboard/')({
  component: ProfileDashboardRoute,
});

function ProfileDashboardRoute() {
  return (
    <ProtectedRoute requiredPermission={Permissions.EmployeeViewBalance}>
      <PayslipDashboard />
    </ProtectedRoute>
  );
} 